import React, { useEffect, useState } from "react";
import RecoverData from "./RecoverData";
import SuperAdminApi from "./SuperAdminApi";
import SuperAdminStore from "./SuperAdminStore";
import WarehouseSync from "./WarehouseSync";
import AccountingReplay from "../Accounting/accountingsettings/AccountingReplay";
import StockDateRecon from "./StockDataRecon";

export default function SuperAdminTab(props) {
  useEffect(() => {
    console.log(props);
  }, []);
  return (
    <div>
      <SuperAdminStore
        messagHandler={props.messagHandler}
        context={props.context}
      ></SuperAdminStore>

      <SuperAdminApi messagHandler={props.messagHandler}></SuperAdminApi>
      {props.context.store.shopType === "WAREHOUSE" && (
        <WarehouseSync
          messagHandler={props.messagHandler}
          setAlert={props.setAlert}
        ></WarehouseSync>
      )}
      {/*<RecoverData
        messagHandler={props.messagHandler}
        setAlert={props.setAlert}
      ></RecoverData>*/}

      <AccountingReplay
        showMessage={props.showMessage}
        setAlert={props.setAlert}
      ></AccountingReplay>
      <div style={{ marginTop: "10px" }}></div>
      <StockDateRecon
        messagHandler={props.messagHandler}
        setAlert={props.setAlert}
      ></StockDateRecon>
    </div>
  );
}
